import { search } from '@/controllers/global/search'
import { getPart } from '@/controllers/library/part'
import type { Part } from '@/interfaces/library'

type PartSearchResult = {
  entityId?: number
  identifier?: string
}

export async function getMappedThreeDPart (
  partNumber: string,
  supplierKey: string
): Promise<Part | null> {
  const limit = 100
  const normalizedSupplierKey = supplierKey.toLowerCase()
  let offset = 0
  let count = 0

  do {
    const { data, headers } = await search({
      limit,
      offset,
      q: `"${partNumber}"`,
      searchable_type: 'PART'
    })
    const results = (data?.items ?? []) as PartSearchResult[]
    const exactMatches = results.filter(({ entityId, identifier }) =>
      identifier === partNumber && Number.isInteger(entityId)
    )
    const settledParts = await Promise.allSettled(
      exactMatches.map(({ entityId }) => getPart(entityId as number))
    )
    const part = settledParts.find(result =>
      result.status === 'fulfilled' &&
      result.value.supplierKey?.toLowerCase() === normalizedSupplierKey
    )
    if (part?.status === 'fulfilled') return part.value

    count = Number(headers?.['x-count']) || offset + results.length
    const nextOffset = Number(headers?.['x-offset']) + Number(headers?.['x-limit'])
    if (!results.length || !Number.isFinite(nextOffset) || nextOffset <= offset) break
    offset = nextOffset
  } while (offset < count)

  return null
}
